import { takeEvery, put, call, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
//IMPORT ACTION TYPES
import {
  GET_LABS_LIST_REQUEST,
  GET_LABS_LIST_SUCCESS,
  GET_LABS_LIST_FAIL,
  GET_BLOCKED_LIST_REQUEST,
  GET_BLOCKED_LIST_SUCCESS,
  GET_BLOCKED_LIST_FAIL,
  GET_ALLLABS_LIST_REQUEST,
  GET_ALLLABS_LIST_SUCCESS,
  GET_ALLLABS_LIST_FAIL,
  GET_REVIEWS_REQUEST,
  GET_REVIEWS_SUCCESS,
  GET_REVIEWS_FAIL,
  GET_EQA_REQUEST,
  GET_EQA_SUCCESS,
  GET_EQA_FAIL,
  DELETE_LAB_REQUEST,
  UNBLOCK_LAB_REQUEST,
  DELETE_LAB_SUCCESS,
  DELETE_LAB_FAIL,
  DELETEP_LAB_REQUEST,
  DELETEP_LAB_SUCCESS,
  DELETEP_LAB_FAIL,
  VERIFY_LAB_REQUEST,
  VERIFY_LAB_SUCCESS,
  VERIFY_LAB_FAIL,
  GET_LAB_DETAIL,
  UPDATE_LAB_REQUEST,
  UPDATE_LAB_SUCCESS,
  UPDATE_LAB_FAIL,
  UPLOAD_REQUEST,
  UPLOAD_PROGRESS,
  UPLOAD_SUCCESS,
  UPLOAD_FAILURE,
} from "./actionTypes";

// IMPORT ACTIONS
import {
  getLabsListRequest,
  getLabsListSuccess,
  getLabsListFail,
  getBlockedListRequest,
  getBlockedListSuccess,
  getBlockedListFail,
  getAllLabsListRequest,
  getAllLabsListSuccess,
  getAllLabsListFail,
  getReviewsListRequest,
  getReviewsListSuccess,
  getReviewsListFail,
  getEqaListRequest,
  getEqaListSuccess,
  getEqaListFail,
} from "./actions";
import {
  deleteLabRequest,
  deleteLabSuccess,
  deleteLabFail,
  deletepLabRequest,
  deletepLabSuccess,
  deletepLabFail,
  getLabDetail,
  getLabDetailSuccess,
  getLabDetailFail,
  unblockLabRequest,
  unblockLabSuccess,
  unblockLabFail,
} from "./actions";
import {
  updateLabRequest,
  updateLabSuccess,
  updateLabFail,
} from "../../store/actions";
import {
  uploadRequest,
  uploadSuccess,
  uploadFailure,
} from "../../store/actions";
import {
  verifyLabRequest,
  verifyLabSuccess,
  verifyLabFail,
} from "../../store/actions";

import axios from "axios";
import PendingVerifications from "pages/Labs/PendingVerifications";
import VerifiedLabs from "pages/Labs/viewverifiedlabs";
import LabProfile1 from "pages/Labs/editprofile";
import { url } from "APIs/URLS";

const LabsListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/profiles/getPendingrequests/`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.labname);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getLabsList() {
  try {
    const response = yield call(LabsListAPICall);
    console.log("data = " + response.data);
    yield put(getLabsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getLabsListFail(error));
  }
}
const ReviewsListAPICall = async id => {
  try {
    const response = await axios.get(`${url}/Feedbacks/getlabreviews/${id}`);
    console.log("data = " + response.data);
    console.log(id);
    console.log("data fetched sucessfully= " + response.data.labname);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getReviewsList({ payload: id }) {
  try {
    const response = yield call(ReviewsListAPICall, id);
    console.log("data = " + response);
    yield put(getReviewsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getReviewsListFail(error));
  }
}
const BlockedListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/profiles/getblockedlabs`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.labname);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getBlockedList() {
  try {
    const response = yield call(BlockedListAPICall);
    console.log("data = " + response.data);
    yield put(getBlockedListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getBlockedListFail(error));
  }
}
const EqasListAPICall = async id => {
  try {
    const response = await axios.get(`${url}/profiles/geteqa/${id}`);
    console.log("data = " + response.data);
    console.log(id);
    console.log("data fetched sucessfully= " + response.data.labname);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getEqasList({ payload: id }) {
  try {
    const response = yield call(EqasListAPICall, id);
    console.log("data = " + response);
    yield put(getEqaListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getEqaListFail(error));
  }
}
//GETTING ALL VERIFIED LABS LIST

//GETTING ALL VERIFIED LABS LIST

const AllLabsListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/profiles/getVerifiedlabs/`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getAllLabsList() {
  try {
    const response = yield call(AllLabsListAPICall);
    console.log("data = " + response.data);
    yield put(getAllLabsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getAllLabsListFail(error));
  }
}
//BLOCK LAB
const DeleteLabAPICall = async lab => {
  //block lab

  const myCall = axios.put(`${url}/profiles/blockLab/${lab.email}`, {
    is_active: false,
  });
  try {
    toast.promise(myCall, {
      loading: " Blocking Lab...",
      success: "Lab Blocked Successfully",
      error: "Error Blocking Lab",
    });
    const response = await myCall;
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onDeleteLab({ payload: lab }) {
  //blocklab
  try {
    const response = yield call(DeleteLabAPICall, lab);
    console.log("delete data = " + response);
    yield put(deleteLabSuccess(response));
  } catch (error) {
    yield put(deleteLabFail(error));
  }
}
//UNBLOCK LAB
const UnblockLabAPICall = async lab => {
  //block lab

  const myCall = axios.put(`${url}/profiles/unblockLab/${lab.email}`, {
    is_active: true,
  });
  try {
    toast.promise(myCall, {
      loading: " Unblocking Lab...",
      success: "Lab unblocked Successfully",
      error: "Error Unblocking Lab",
    });
    const response = await myCall;
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onUnblockLab({ payload: lab }) {
  //blocklab
  try {
    const response = yield call(UnblockLabAPICall, lab);
    console.log("unblock data = " + response);
    yield put(unblockLabSuccess(response));
  } catch (error) {
    yield put(unblockLabFail(error));
  }
}
//DELETE LAB
const DeletepLabAPICall = async lab => {
  //delete lab

  const myCall = axios.delete(`${url}/profiles/deleteLab/${lab.email}`, {
    is_active: false,
  });
  try {
    toast.promise(myCall, {
      loading: " Rejecting Lab...",
      success: "Lab Rejected Successfully",
      error: "Error Rejected Lab",
    });
    const response = await myCall;
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onDeletepLab({ payload: lab }) {
  //deletelab
  try {
    const response = yield call(DeletepLabAPICall, lab);
    console.log("delete data = " + response);
    yield put(deletepLabSuccess(response));
  } catch (error) {
    yield put(deletepLabFail(error));
  }
}
//VERIFY LAB
const VerifyLabAPICall = async lab => {
  //verify lab

  const myCall = axios.put(`${url}/profiles/verifyLab/${lab.email}`, {
    verified: true,
  });
  try {
    toast.promise(myCall, {
      loading: " verifying Lab...",
      success: "Lab verified Successfully",
      error: "Error verifying Lab",
    });
    const response = await myCall;
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onVerifyLab({ payload: lab }) {
  try {
    const response = yield call(VerifyLabAPICall, lab);
    console.log("verified = " + response);
    yield put(verifyLabSuccess(response));
  } catch (error) {
    yield put(verifyLabFail(error));
  }
}
//UPDATE LAB PROFILE

const UpdateLabAPICall = async (lab, email) => {
  console.log("lab passed", lab);
  console.log("email passed", email);
  const promise = axios.put(`${url}/profiles/updateLabDetails/${email}`, lab);
  console.log("promise = " + promise);
  try {
    toast.promise(promise, {
      loading: "Updating Profile...",
      success: "Lab Updated Successfully",
      error: "Error Updating Lab",
    });
    const response = await promise;
    console.log("reponse=await promise", response);
    console.log("reponse.data", response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onUpdateLab({ payload: { lab, email } }) {
  try {
    const response = yield call(UpdateLabAPICall, lab, email);
    console.log("Update data = " + response);
    yield put(updateLabSuccess(response));
  } catch (error) {
    yield put(updateLabFail(error));
  }
}

//GET LAB DETAIL
export const getLabDetailAPIfunction = async email => {
  try {
    const response = await axios.get(`${url}/profiles/getLabDetails/${email}`);
    console.log("data recieved  = " + response.data.email);
    console.log("lab object  = " + JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};
function* fetchLabDetail({ payload: email }) {
  try {
    const response = yield call(getLabDetailAPIfunction, email);
    yield put(getLabDetailSuccess(response));
  } catch (error) {
    yield put(getLabDetailFail(error));
    console.log(error);
  }
}
//UPLOAD FILES IN DB
const UploadImageAPICall = async (file, email) => {
  console.log("lab passed", file);
  console.log("email passed", email);
  const promise = axios.post(`${url}/profiles/updateLabDetails/${email}`, {
    Logo: file,
  });
  console.log("promise for image = " + promise);
  try {
    toast.promise(promise, {
      loading: "Uploading Image...",
      success: "Image Upoaded Successfully",
      error: "Error Uploading Image",
    });
    const response = await promise;
    console.log("reponse=await promise", response);
    console.log("reponse.data", response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onUploadImage({ payload: { file, email } }) {
  try {
    const response = yield call(UploadImageAPICall, file, email);
    console.log("Uploaded Image= " + response);
    yield put(uploadSuccess(response));
  } catch (error) {
    yield put(uploadFailure(error));
  }
}

function* LabsSaga() {
  yield takeEvery(GET_LABS_LIST_REQUEST, getLabsList);
  yield takeEvery(GET_BLOCKED_LIST_REQUEST, getBlockedList);
  yield takeEvery(GET_ALLLABS_LIST_REQUEST, getAllLabsList);
  yield takeEvery(GET_EQA_REQUEST, getEqasList);
  yield takeEvery(DELETE_LAB_REQUEST, onDeleteLab);
  yield takeEvery(UNBLOCK_LAB_REQUEST, onUnblockLab);
  yield takeEvery(DELETEP_LAB_REQUEST, onDeletepLab);
  yield takeEvery(VERIFY_LAB_REQUEST, onVerifyLab);
  yield takeEvery(GET_LAB_DETAIL, fetchLabDetail);
  yield takeEvery(UPDATE_LAB_REQUEST, onUpdateLab);
  yield takeEvery(GET_REVIEWS_REQUEST, getReviewsList);
  yield takeEvery(UPLOAD_REQUEST, onUploadImage);
}

export default LabsSaga;
